import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, nullOrUndefined, boolean, number } from "@altostra/type-validations/lib/primitives";

export const isEngagementSegmentPutResult = objectOf({
  segment: objectOf({
    id: string,
    app_group_id: string,
    app_ids: arrayOf(string),
    name: string,
    description: string,
    is_archived: boolean,
    filters: arrayOf(
      objectOf({
        filter_key: string,
        display_name: string,
        varies_by_app_group: boolean,
        allowed_for_territories: boolean,
        only_for_workflow_step: boolean,
        allowed_for_predictions: boolean,
        additional_filter_data: objectOf({}),
        value: string,
        comparison_key: string,
        filters: arrayOf(
          objectOf({
            filter_key: string,
            display_name: string,
            varies_by_app_group: boolean,
            allowed_for_territories: boolean,
            only_for_workflow_step: boolean,
            allowed_for_predictions: boolean,
            additional_filter_data: objectOf({}),
            value: objectOf({
              id: string,
              value: string,
            }),
            comparison_key: string,
          })
        ),
      })
    ),
    created_at: number,
    updated_at: number,
    updated_by: string,
    enable_analytics_tracking: boolean,
    api_identifier: string,
    tag_names: arrayOf(string),
    territory_ids: arrayOf(string),
    changelog_count: number,
    include_all_apps: boolean,
    include_users_without_app: boolean,
    campaigns_using_segment: objectOf({
      count: number,
      data: arrayOf(string),
    }),
    cards_using_segment: objectOf({
      count: number,
      data: arrayOf(string),
    }),
    workflows_using_segment: objectOf({
      count: number,
      data: arrayOf(string),
    }),
    segments_using_segment: objectOf({
      count: number,
      data: arrayOf(string),
    }),
  }),
  prevent_more_analytics: boolean,
  segment_filter_types: arrayOf(
    objectOf({
      filter_key: string,
      display_name: string,
      varies_by_app_group: boolean,
      allowed_for_territories: boolean,
      only_for_workflow_step: boolean,
      allowed_for_predictions: boolean,
      additional_filter_data: objectOf({}),
      valid_comparisons_dictionary: objectOf({
        "1": string,
        "2": string,
      }),
      grouped_comparisons: nullOrUndefined,
      valid_values: string,
      default_value: string,
      default_comparison: string,
      is_remote: boolean,
      remote_value_count: number,
      requires_values: boolean,
      valid_values_restricted_for_look_back: boolean,
      data_type: nullOrUndefined,
    })
  ),
});
